import Dexie from "dexie";

const db = new Dexie("TamboPAL");

db.version(1).stores({
  // Animales y rodeo
  animales: "++localId, id, caravana, categoria, estado, lote_id, tambo_id",
  lotes: "++localId, id, nombre, tambo_id",

  // Feedlot
  corrales_feedlot: "++localId, id, nombre, tipo, tambo_id",
  corrales_asignaciones: "++localId, id, animal_id, corral_id, tambo_id",
  registros_peso: "++localId, id, animal_id, tambo_id",
  enfermedades_feedlot: "++localId, id, animal_id, tambo_id",
  recorridos_corral: "++localId, id, corral_id, tambo_id",

  // Agricultura
  siembras: "++localId, id, tambo_id",
  cosechas: "++localId, id, tambo_id",
  picados: "++localId, id, tambo_id",
  inventario_siembra: "++localId, id, tambo_id",

  // Sanidad
  inventario_veterinario: "++localId, id, tambo_id",
  inseminaciones: "++localId, id, animal_id, tambo_id",
  tactos: "++localId, id, animal_id, tambo_id",

  // Tareas
  tareas: "++localId, id, tambo_id",

  // Cola de operaciones pendientes
  pendingOps: "++id, createdAt, tabla, accion, synced, [synced+createdAt]",
});

export default db;
